module.exports = "img/7.d6e21b.webp";